import React from 'react';
import { AbTestType } from '../../../../../models/AbTestType';

interface StatusLabelProps {
  status: AbTestType;
}

export default function StatusLabel({ status }: StatusLabelProps) {
  const formattedStatus = status.toLowerCase();
  return <span className={`status-label status-label--${formattedStatus}`}>{formattedStatus}</span>;
}
